import React, { useState, useEffect } from "react"
import "./Home.css"
import { Layout, NumberDisplay } from "components"
import {
  Card,
  Button,
  CardHeader,
  CardFooter,
  CardBody,
  Row,
  Col,
  Alert,
  Table,
  Container,
} from "reactstrap"
import { FaSyncAlt } from "react-icons/fa"
import colors from "assets/colors"
import dayjs from "dayjs"
import { fetchDashboard } from "api/dashboardApi"
import { DatePicker } from "reactstrap-date-picker"
import { Loader } from "components"
import DashboardSection from "./DashboardSection"

function Home(props) {
  const [isLoading, setIsLoading] = useState(false)
  const today = dayjs()
  const startDate = today.subtract(7, "day").format("YYYY-MM-DD")
  const [error, setError] = useState(null)

  const [params, setParams] = useState({
    startDate: today.format("YYYY-MM-DD"),
    endDate: today.format("YYYY-MM-DD"),
  })

  const [trigger, setTrigger] = useState(0)

  const refresh = async () => {
    setTrigger((prev) => prev + 1)
    // fetchData()
  }

  const [dashboard, setDashboard] = useState({
    admin: {},
    partner: {},
    member: {},
    current: {},
  })

  const fetchData = async () => {
    // setIsLoading(true)
    try {
      const { success, message, data } = await fetchDashboard(params)

      if (!success) throw new Error(message)
      setDashboard(data)
    } catch (error) {
      console.error(error)
      setError(error)
    } finally {
      setIsLoading(false)
    }
  }

  const handleStartDateChange = (date) => {
    const formattedDate = new Date(date).toISOString().split("T")[0]
    setParams((prevParams) => ({
      ...prevParams,
      startDate: formattedDate,
    }))
  }

  const handleEndDateChange = (date) => {
    const formattedDate = new Date(date).toISOString().split("T")[0]
    setParams((prevParams) => ({
      ...prevParams,
      endDate: formattedDate,
    }))
  }

  const handleFormSubmit = (e) => {
    e.preventDefault()
    setTrigger((prev) => prev + 1)
    fetchData()
  }

  useEffect(() => {
    // fetchData()
  }, [])

  return (
    <Layout>
      <Table>
        <tbody className="align-items-center">
          <tr>
            <td xs={9}>
              <div className="d-flex align-items-center justify-content-center">
                <div className="me-3">
                  <DatePicker
                    value={params.startDate}
                    onChange={handleStartDateChange}
                    className="form-control form-control-sm"
                    placeholder="시작일"
                    showClearButton={false}
                    dateFormat="YYYY-MM-DD"
                    maxDate={new Date(params.endDate).toString()}
                  />
                </div>

                <div className="me-3">
                  <DatePicker
                    value={params.endDate}
                    onChange={handleEndDateChange}
                    className="form-control form-control-sm"
                    placeholder="종료일"
                    showClearButton={false}
                    dateFormat="YYYY-MM-DD"
                    minDate={new Date(params.startDate).toString()}
                  />
                </div>

                <Button
                  style={{
                    backgroundColor: colors.primary,
                    borderColor: colors.primary,
                  }}
                  onClick={handleFormSubmit}
                  color="primary"
                  size="sm"
                >
                  검색
                </Button>

                <button className="btn btn-link" onClick={refresh}>
                  <FaSyncAlt style={{ color: colors.primary }} />
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </Table>
      <Container style={{ padding: 10 }}>
        {/* {isLoading && <Loader />} */}
        {error && <Alert color="danger">{"에러"}</Alert>}
        {/* <Row className='d-flex justify-content-center p-2'>
          <Button
            color='primary'
            style={{ textAlign: 'center', width: 200 }}
            onClick={refresh}
          >
            새로고침
          </Button>
        </Row> */}
        <Row>
          <Col xs="12" sm="6" md="4" lg="3">
            <DashboardSection
              trigger={trigger}
              type="admin"
              title="관리자 현황"
              params={{
                ...params,
                type: "admin",
              }}
              fields={[
                { label: "신규 관리자", key: "newAdmins", suffix: "명" },
                { label: "탈퇴 관리자", key: "withdrawnAdmins", suffix: "명" },
                // { label: "전체", key: "total", suffix: "명", isFooter: true },
              ]}
            />
          </Col>

          <Col xs="12" sm="6" md="4" lg="3">
            <DashboardSection
              trigger={trigger}
              type="partner"
              title="파트너 현황"
              params={{
                ...params,
                type: "partner",
              }}
              fields={[
                { label: "신규 파트너", key: "newPartners", suffix: "명" },
                {
                  label: "탈퇴 파트너",
                  key: "withdrawnPartners",
                  suffix: "명",
                },
                // { label: "전체", key: "total", suffix: "명", isFooter: true },
              ]}
            />
          </Col>

          <Col xs="12" sm="6" md="4" lg="3">
            <DashboardSection
              trigger={trigger}
              type="member"
              title="회원 현황"
              params={{
                ...params,
                type: "user",
              }}
              fields={[
                { label: "신규 회원", key: "newUsers", suffix: "명" },
                { label: "탈퇴 회원", key: "withdrawnUsers", suffix: "명" },
                // { label: "전체", key: "total", suffix: "명", isFooter: true },
              ]}
            />
          </Col>

          <Col xs="12" sm="6" md="4" lg="3">
            <DashboardSection
              trigger={trigger}
              params={{
                ...params,
                type: "session",
              }}
              type="session"
              title="현재 접속 현황"
              fields={[
                { label: "관리자", key: "admin", suffix: "명" },
                { label: "파트너", key: "partner", suffix: "명" },
                { label: "실회원", key: "activeMember", suffix: "명" },
                { label: "주의회원", key: "cautionMember", suffix: "명" },
                { label: "전체", key: "total", suffix: "명", isFooter: true },
              ]}
            />
          </Col>

          <Col xs="12" sm="6" md="4" lg="3">
            <DashboardSection
              trigger={trigger}
              params={{
                ...params,
                type: "transaction",
              }}
              type="transaction"
              title="입출 현황"
              fields={[
                { label: "입금", key: "deposit", suffix: "원" },
                { label: "출금", key: "withdrawal", suffix: "원" },
                {
                  label: "입출차액",
                  key: "total",
                  suffix: "원",
                  isFooter: true,
                },
              ]}
            />
          </Col>

          <Col xs="12" sm="6" md="4" lg="3">
            <DashboardSection
              trigger={trigger}
              params={{
                ...params,
                type: "casinoUserBalance",
              }}
              type="casinoUserBalance"
              title="회원 보유금 [카지노]"
              fields={[
                { label: "보유금", key: "balance", suffix: "원" },
                {
                  label: "관리자 증가 보유금",
                  key: "adminIncBalance",
                  suffix: "원",
                },
                {
                  label: "관리자 감소 보유금",
                  key: "adminDecBalance",
                  suffix: "원",
                },
                {
                  label: "포인트 전환 보유금",
                  key: "balanceConversion",
                  suffix: "원",
                },
              ]}
            />
          </Col>

          <Col xs="12" sm="6" md="4" lg="3">
            <DashboardSection
              trigger={trigger}
              params={{
                ...params,
                type: "casinoUserPoint",
              }}
              type="casinoUserPoint"
              title="회원 포인트 [카지노]"
              fields={[
                { label: "포인트", key: "point", suffix: "P" },
                {
                  label: "관리자 증가 포인트",
                  key: "adminIncPoint",
                  suffix: "원",
                },
                {
                  label: "관리자 감소 포인트",
                  key: "adminDecPoint",
                  suffix: "원",
                },
                {
                  label: "시스템 증감 포인트",
                  key: "systemConversion",
                  suffix: "원",
                },
              ]}
            />
          </Col>

          <Col xs="12" sm="6" md="4" lg="3">
            <DashboardSection
              trigger={trigger}
              params={{
                ...params,
                type: "sportsUserBalance",
              }}
              type="sportsUserBalance"
              title="회원 보유금 [스포츠]"
              fields={[
                { label: "보유금", key: "balance", suffix: "원" },
                {
                  label: "관리자 증가 보유금",
                  key: "adminIncBalance",
                  suffix: "원",
                },
                {
                  label: "관리자 감소 보유금",
                  key: "adminDecBalance",
                  suffix: "원",
                },
                {
                  label: "포인트 전환 보유금",
                  key: "balanceConversion",
                  suffix: "원",
                },
              ]}
            />
          </Col>

          <Col xs="12" sm="6" md="4" lg="3">
            <DashboardSection
              trigger={trigger}
              params={{
                ...params,
                type: "sportsUserPoint",
              }}
              type="sportsUserPoint"
              title="회원 포인트 [스포츠]"
              fields={[
                { label: "포인트", key: "point", suffix: "P" },
                {
                  label: "관리자 증가 포인트",
                  key: "adminIncPoint",
                  suffix: "원",
                },
                {
                  label: "관리자 감소 포인트",
                  key: "adminDecPoint",
                  suffix: "원",
                },
                {
                  label: "시스템 증감 포인트",
                  key: "systemConversion",
                  suffix: "원",
                },
              ]}
            />
          </Col>
        </Row>
      </Container>
    </Layout>
  )
}

export default Home
